import React, { useEffect, useState } from "react";
import { Box, Typography, Tabs, Tab, Grid, Checkbox, Button, Stepper, Step, StepLabel, TextField } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import ProductInfo from "./ProductInfo";
import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled, setHideTaskActionBar } from "store/slice/AppSlice";
import { setTaskApiResponse, setTaskApiResponseError } from 'store/slice/AppSlice';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import PmorderDashboard from "components/pmorder/PmorderDashboard";
import { getListAPI as getPMunitList } from 'components/dmunit/DmunitAPI';
import { setDmunitList } from "store/slice/PharmaSlice";
import { getPmorderInfoByProductidAPI } from 'components/pmorder/PmorderAPI';
import { setPmorderList, setPmorderDashboardPmorderList } from "store/slice/PharmaSlice";
import { placePMorderAPI } from "api/OmsOrdermgmtWebServices";
import MuiAlert from '@mui/material/Alert';
import { initRefreshTaskList } from "store/slice/AppSlice";
import { updateProductInfo } from "components/product/ProductAPI";
import {updateProductObj} from "store/slice/PharmaSlice";
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FieldView2 from "core/components/layout/FieldView2";
import CommentMgmt from "./comment/CommentMgmt";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';



export default function TaskSpaceDesignerPlaceOrder() {
  const dispatch = useDispatch();

  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { selectedTaskObj } = useSelector((state) => state.appslice.wkflow);
  const { taskApiResponse, taskApiResponseError } = useSelector((state) => state.appslice.wkflow);
  const [designMaterialAvailable, setDesignMaterialAvailable] = useState(productObj.designstatus);
  const [orderDate, setOrderDate] = useState("");
  const { pmorderList } = useSelector((state) => state.pharmaslice.pmorderDashboard);
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const [editSetNameOpen, setEditSetNameOpen] = useState(false);
  const [setNameInput, setSetNameInput] = useState(productObj.setname || "");
  const [setNameSaving, setSetNameSaving] = useState(false);
  const [canComplete, setCanComplete] = useState(false);
  const {showEdit} = useSelector((state) => state.pharmaslice.pmorderDashboard);
  const [tabIndex, setTabIndex] = useState(0);
  const {pharmasetList} = useSelector(state => state.pharmaslice);
  const {taskCompleted} = useSelector(state => state.appslice.wkflow);

  useEffect(() => {
    if (showEdit)
      dispatch(setCompleteTaskButtonEnabled(false));
    else
      dispatch(setCompleteTaskButtonEnabled(true));

  },[showEdit]);

  useEffect(() => { 
    setIsOrderPlaced( taskCompleted );
  },[taskCompleted]);

  useEffect(() => {
    //dispatch(setHideTaskActionBar(true));
    //if (pmorderList.length > 0) setDesignMaterialAvailable('no');
    dispatch(setTaskApiResponseError(''));
  }, [pmorderList])
  useEffect(() => {
    // Convert ISO date to yyyy-MM-dd format for the input
    if (productObj.designorderedon) {
      const date = new Date(productObj.designorderedon);
      if (!isNaN(date)) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        setOrderDate(`${yyyy}-${mm}-${dd}`);
      } else {
        setOrderDate("");
      }
    } else {
      setOrderDate("");
    }
  }, [productObj]);

  useEffect(() => {
    // dispatch(setTaskApiResponse(null));
    // dispatch(setTaskApiResponseError(''));
    // Enable Complete button only if canCompleteTask() returns true
    //setCanComplete( canCompleteTask() );
    if (canCompleteTask()){
      dispatch(setCompleteTaskButtonEnabled(true));
    } else 
    {
      dispatch(setCompleteTaskButtonEnabled(false));
    }
  },[productObj,pmorderList, isOrderPlaced]);

  useEffect(() => {
    dispatch(setTaskApiResponse(null));
    dispatch(setTaskApiResponseError(''));
    dispatch(setCompleteTaskButtonEnabled(false));
    dispatch(setHideTaskActionBar(false));
    dispatch(setPmorderList([]));
    dispatch(setPmorderDashboardPmorderList([]));

    getPMunitList(() => { }, (list) => { dispatch(setDmunitList(list)) });

    getPmorderInfoByProductidAPI(productObj.id, () => { }, (response) => {
      dispatch(setPmorderList(response));
      dispatch(setPmorderDashboardPmorderList(response));
    });
    console.log("designMaterialAvailable=>productObj=>" + productObj.designstatus);
  }, []);
  useEffect(() => {
    
    if (designMaterialAvailable !== productObj.designstatus)
        updateProductInfo(
          productObj.id,{ 
            designstatus: designMaterialAvailable
          },
          (response) => {
            dispatch(updateProductObj(response));
          },
          (error) => {
            console.error("Error updating design material", error);
            dispatch(setTaskApiResponseError(error));
          }
        );
  },[designMaterialAvailable]);

 const updateOrderDate = (date) => {
  updateProductInfo(
        productObj.id,{ 
          designorderedon: date
        },
        (response) => {
          dispatch(updateProductObj(response));
        },
        (error) => {
          console.error("Error updating design material", error);
          dispatch(setTaskApiResponseError(error));
        }
      );
 }

const completeTask = () => {
  placePMorderAPI({
    productId: productObj.id,
    orderDate: orderDate,
    taskInstanceId: selectedTaskObj.id,
  }, (response) => {
    dispatch(initRefreshTaskList());
    dispatch(setPmorderDashboardPmorderList(response.pmorderInfoList.list));
    setIsOrderPlaced(true);
  }, (error) => {
    dispatch(setTaskApiResponseError(error));
  });
}

const handleEditSetNameOpen = () => {
  setSetNameInput(productObj.setname || "");
  setEditSetNameOpen(true);
};

const handleEditSetNameClose = () => {
  setEditSetNameOpen(false);
};

const handleSetNameSave = () => {
  console.log("setNameInput=>" + setNameInput);
  setSetNameSaving(true);
  updateProductInfo(
    productObj.id,
    { setname: setNameInput },
    (response) => {
      dispatch(updateProductObj(response));
      setEditSetNameOpen(false);
      setSetNameSaving(false);
    },
    (error) => {
      setSetNameSaving(false);
      // Optionally show error
    }
  );
};
const canCompleteTask = () => {

  if (isOrderPlaced) return false;
  
  if (selectedTaskObj.taskid===60){ // Designer - PM Check
    if (productObj.designstatus==='') return false; // Not selected any of the Radio button
    if (productObj.designstatus==='ORDERED' && productObj.designorderedon===null) return false; // Order placed but no date selected
    if (productObj.designstatus==='STOCK_CHECK' && pmorderList.length===0) return false; // Stock Check selected but no order placed
    return true;  
  
  } else if (selectedTaskObj.taskid===112){ // STORE - Stock Check
   if (pmorderList.length===0) return false; // Stock Check selected but no order placed
   return true;

  } else if (selectedTaskObj.taskid===113){ // PM Stock Review
    if (productObj.designstatus==='' || productObj.designstatus==='STOCK_CHECK') return false; // Not selected any of the Radio button
    if (productObj.designstatus==='ORDERED' && productObj.designorderedon===null) return false;
    if (productObj.designstatus==='AVAILABLE') return true;
    
    return true;
  }
  
};

  return (
    <Grid container direction="row" sx={{ width: '100%' }}>
      <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mb: 2 }}>
        <Grid container sx={{ width: '100%' }}>
          <Grid item lg={4} md={4} sm={12} xs={12}>
                  <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
                    <Tabs
                      value={tabIndex}
                      onChange={(_, v) => setTabIndex(v)}
                      variant="fullWidth"
                      sx={{ borderBottom: 1, borderColor: 'divider' }}
                    >
                      <Tab label="Product Info" />
                      <Tab label="Comments" />
                    </Tabs>
                    <Box sx={{}}>
                      {tabIndex === 0 && (
                        <ProductInfo maxHeight="70vh" />
                      )}
                      {tabIndex === 1 && (
                        <Box sx={{ p: 2, minHeight: '70vh' }}>
                          <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                            <CommentMgmt maxHeight="60vh" status={1} />
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid>
          <Grid item lg={8} md={4} sm={4} xs={12}>
            <Grid container direction="column" sx={{ width: '100%' }}>
               {(selectedTaskObj.taskid==60 || selectedTaskObj.taskid==113) && (
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{mb:2}}>
                <Box sx={{ p: 2, background: "white", borderRadius: 2 }}>
                  <Grid container alignItems="center" >
                   
                      <Grid item lg={12?designMaterialAvailable === 'ORDERED':6} >
                        <FormControl component="fieldset" sx={{ width: "100%" }}>
                          <FormLabel component="legend">Next Step for Design Material?</FormLabel>
                          <RadioGroup
                            row
                            value={designMaterialAvailable}
                            onChange={e => setDesignMaterialAvailable(e.target.value)}
                            name="design-material-available"
                            disabled={isOrderPlaced}
                          >
                          
                            {selectedTaskObj.taskid===113 ?
                              <FormControlLabel value="AVAILABLE" control={<Radio />} disabled={isOrderPlaced} label="Available"  />:
                            <FormControlLabel value="STOCK_CHECK" control={<Radio />} disabled={isOrderPlaced} label="Stock Check" />
                            }
                            <FormControlLabel value="ORDERED" control={<Radio />} disabled={isOrderPlaced} label="Place Order"  />
                            
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                    {designMaterialAvailable === 'ORDERED' && (
                      <Grid item lg={6}>
                        <Box sx={{ display: designMaterialAvailable === 'ORDERED'?"flex":"none", alignItems: "center",  }}>
                          <Typography variant="h6" color="primary.darker" sx={{ whiteSpace: "nowrap", mr: 2 }}>
                            Order Placed On
                          </Typography>
                          <TextField
                            label="Order Date"
                            type="date"
                            size="small"
                            sx={{ minWidth: 180 }}
                            InputLabelProps={{ shrink: true }}
                            value={orderDate}
                            onChange={e => updateOrderDate(e.target.value)}
                            disabled={isOrderPlaced}
                          />
                        </Box>
                      </Grid>
                       )}
                  </Grid>
                </Box>

              </Grid>
              )}
              {/* <Grid item lg={12} md={12} sm={12} xs={12} sx={{ backgroundColor: 'white', padding: 1, borderRadius: 2 }}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                  <Grid item lg={11} md={4} sm={4} xs={4} >
                    <FieldView2 label="Set Name" value={productObj.setname} />
                  </Grid>
                  <Grid item lg={1} md={1} sm={1} xs={2}>
                    <IconButton size="small" color="primary" onClick={handleEditSetNameOpen} disabled={isOrderPlaced}>
                      <EditIcon disabled={isOrderPlaced}/>
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid> */}
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mt: 2 }}>
                <Box sx={{ borderRadius: 2,  }}>
                  <Grid container>
                    {/* {designMaterialAvailable === 'ORDERED' && ( */}
            
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{backgroundColor:'white', borderRadius: 2, p: 2 }}>
                      {!isOrderPlaced ? (
                        <PmorderDashboard />
                      ) : (
                        <>
                        <Grid container direction="row" sx={{}}>
                          {pmorderList && pmorderList.length > 0 ? (
                            pmorderList.map((order, idx) => (
                              <Grid item lg={3} md={2} sm={2} xs={4} key={order.id || idx} sx={{ p: 1 }}>
                                <Box
                                  key={order.id || idx}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5,
                                    mb: 1,
                                    alignItems: "flex-start",
                                    backgroundColor: "secondary.100",
                                    borderRadius: 1,
                                    p: 1.5,
                                  }}
                                >
                                  <Typography variant="h5" sx={{ fontWeight: 500 }}>
                                    {order.title}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    {order.orderedqty} {order.unitname}
                                  </Typography>
                                </Box>
                                </Grid>
                            ))
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              No orders found.
                            </Typography>
                          )}
                          </Grid>
                        </>
                      )}
                    </Grid> 
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Set Name Edit Dialog */}
      <Dialog open={editSetNameOpen} onClose={handleEditSetNameClose} maxWidth="xs" fullWidth>
        <DialogTitle>Edit Set Name</DialogTitle>
        <DialogContent>
          <Select
            label="Set Name"
            value={setNameInput}
            onChange={e => setSetNameInput(e.target.value)}
            fullWidth
            sx={{ mt: 1 }}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select Set Name
            </MenuItem>
            {pharmasetList && pharmasetList.map((set) => (
              <MenuItem key={set.id || set.title} value={set.title}>
                {set.title}
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditSetNameClose} color="secondary" disabled={setNameSaving}>
            Cancel
          </Button>
          <Button
            onClick={handleSetNameSave}
            color="primary"
            variant="contained"
            //disabled={!setNameInput.trim() || setNameSaving}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}